import CategoryProducts from "../../../features/categoryProducts/CategoryProducts";

function CategoryProductsPage() {
  return <CategoryProducts />;
}

export default CategoryProductsPage;
